import dayjs from "dayjs";
import packageJson from "../../package.json";
import styled, { useTheme } from "styled-components";
import { buildCode } from "../helpers/config";
import { AppTheme } from "../theme";
import { Heart } from "lucide-react";

export function Copyright() {
  const year = dayjs().format("YYYY");
  const theme = useTheme() as AppTheme;

  return (
    <CopyrightTemplate $theme={theme}>
      <CopyrightText $theme={theme}>
        Made with <HeartIcon $theme={theme}><Heart size={12} fill="currentColor" /></HeartIcon> by Jan Osio
      </CopyrightText>
      <VersionText $theme={theme}>
        © {year} • v{packageJson.version} • {buildCode}
      </VersionText>
    </CopyrightTemplate>
  );
}

const CopyrightTemplate = styled.div<{ $theme: AppTheme }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 1rem;
  gap: 0.35rem;
`;

const CopyrightText = styled.div<{ $theme: AppTheme }>`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 13px;
  font-weight: 500;
  color: ${({ $theme }) => $theme.textSecondary};
  font-family: 'Plus Jakarta Sans', sans-serif;
`;

const HeartIcon = styled.span<{ $theme: AppTheme }>`
  color: ${({ $theme }) => $theme.red};
  display: inline-flex;
  animation: heartbeat 1.5s ease-in-out infinite;
  
  @keyframes heartbeat {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.15); }
  }
`;

const VersionText = styled.div<{ $theme: AppTheme }>`
  font-size: 11px;
  color: ${({ $theme }) => $theme.textMuted};
  font-family: 'Plus Jakarta Sans', sans-serif;
  letter-spacing: 0.02em;
`;
